/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {
    Observable,
    ReplaySubject,
    Subject
} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UnsavedChangesService {

    public emitValue = new Subject<boolean>();
    current: any;
    private subject = new ReplaySubject<boolean>(1);
    private originalJson: string;
    private currentJson: string;
    private original: any;

    get onChange(): Observable<boolean> {
        return this.subject.asObservable();
    }

    set originalValue(value: any) {
        this.current = this.original = this.removeDeepNull(value);
        this.currentJson = this.originalJson = JSON.stringify(this.original);

        this.subject.next(false);
    }

    set currentValue(value: any) {
        this.current = this.removeDeepNull(value);
        this.currentJson = JSON.stringify(this.current);

        this.subject.next(this.currentJson !== this.originalJson);
    }

    set currentDelta(value: any) {
        this.currentValue = {...this.current, ...value};
    }

    public isChanged(): boolean {
        return this.originalJson !== this.currentJson;
    }

    /**
     * This is to be used in the cases when we need to ignore the guard that keep or leave the page
     */
    public ignoreChanges(): void {
        this.currentValue = this.original;
    }

    public resetOriginalValue(): void {
        this.originalValue = null;
    }

    private removeDeepNull<T>(value: T, useClone: boolean = true): T {
        if (value == null) {
            return value;
        }

        const deepCopy: T = useClone ? JSON.parse(JSON.stringify(value)) : value;

        for (const propName in deepCopy) {
            if (deepCopy.hasOwnProperty(propName)) {
                if (deepCopy[propName] == null) {
                    delete deepCopy[propName];
                } else if (deepCopy[propName] instanceof Object) {
                    deepCopy[propName] = this.removeDeepNull(deepCopy[propName], false);
                }
            }
        }

        return deepCopy;
    }
}
